import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom"; 
import { getFirestore, doc, setDoc, getDoc,query,where, getDocs , updateDoc, collection } from "firebase/firestore";
import { db } from "../firebase"; 
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
 
import { Helmet } from "react-helmet";  
import Lodinging from "../components/loading";  
import Cookies from 'js-cookie';
import { useToast } from '../components/ToastContext';    
import Header from '../master_root/header';
//page links  
export default function Demo() {
  return (
       <div >
         <Header /> 
       <div className='app_header_height'></div>
    <div className="container_roots">
  
    <Helmet>
  <title> Job Task  </title>

  <meta name="description" content="Post freelance jobs easily on EditorTask. Connect with top editors, graphic designers, video editors, and content creators across India. Hire now!" />
  <meta name="keywords" content="post a job, hire freelancers, freelance jobs India, hire editors, hire designers, post freelance work, job posting, find creative talent" />
  <meta name="author" content="EditorTask.com" />
  <meta name="robots" content="index, follow" />

  <meta property="og:title" content="Post a Job - Hire Freelance Editors, Designers & Creators | EditorTask" />
  <meta property="og:description" content="Easily post your freelance job and hire skilled editors, designers, writers, and video creators on EditorTask." />
  <meta property="og:type" content="website" />
  <meta property="og:url" content="https://www.editortask.com/post-job" />
  <meta property="og:image" content="https://www.editortask.com/images/editortask_og_banner.png" />

  <link rel="canonical" href="https://www.editortask.com/post-job" />
</Helmet>

      <div className="container_size">
        <div className='post-container'>

          <div className='post_updates'>post_updates</div>
          <div className='post_div'>post_div</div>
        </div>
      </div>
</div>
</div>
    );
}
